import React from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Input,
  Badge,
  Image,
  Typography,
  Button,
} from "antd";
import { ShoppingOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";

const { Title, Text } = Typography;
const { Search } = Input;

interface SalesRecord {
  key: string;
  customerIncentiveCode: string;
  dateValidated: string;
  saleExpireDate: string;
  customerName: string;
}

const SalesInProgress: React.FC = () => {
  const salesData: SalesRecord[] = [
    {
      key: "1",
      customerIncentiveCode: "0b7Lst",
      dateValidated: "02/14/2025",
      saleExpireDate: "02/14/2025",
      customerName: "Ethan Soloman",
    },
    {
      key: "2",
      customerIncentiveCode: "5d6dsd",
      dateValidated: "02/14/2025",
      saleExpireDate: "02/14/2025",
      customerName: "Alison Denton",
    },
    {
      key: "3",
      customerIncentiveCode: "1d2s3s",
      dateValidated: "02/01/2025",
      saleExpireDate: "02/01/2025",
      customerName: "Gilberto Mesa",
    },
    {
      key: "4",
      customerIncentiveCode: "88d33m",
      dateValidated: "02/01/2025",
      saleExpireDate: "02/01/2025",
      customerName: "Gustavo Calderon",
    },
  ];

  const ActionButtons: React.FC = () => (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <Button
        type="link"
        style={{
          color: "#389E0D",
          padding: 0,
          textDecoration: "underline",
          fontFamily: "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
          fontSize: "16px",
          fontWeight: "400",
        }}
      >
        Submit Reimbursement Request
      </Button>
      <div
        style={{
          width: "1px",
          height: "15px",
          backgroundColor: "#CCC",
          border: "1px solid #CCC",
        }}
      />
      <Button
        type="link"
        style={{
          color: "#08979C",
          padding: 0,
          textDecoration: "underline",
          fontFamily: "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
          fontSize: "16px",
          fontWeight: "400",
        }}
      >
        Extend
      </Button>
      <div
        style={{
          width: "1px",
          height: "15px",
          backgroundColor: "#CCC",
          border: "1px solid #CCC",
        }}
      />
      <Button
        type="link"
        style={{
          color: "#CF1322",
          padding: 0,
          textDecoration: "underline",
          fontFamily: "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
          fontSize: "16px",
          fontWeight: "400",
        }}
      >
        Cancel
      </Button>
    </div>
  );

  const columns: ColumnsType<SalesRecord> = [
    {
      title: "Customer Incentive Code",
      dataIndex: "customerIncentiveCode",
      key: "customerIncentiveCode",
      render: (text) => (
        <span
          style={{
            fontFamily:
              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
            fontSize: "16px",
            fontWeight: "400",
            color: "#4D4D4D",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Date Validated",
      dataIndex: "dateValidated",
      key: "dateValidated",
      render: (text) => (
        <span
          style={{
            fontFamily:
              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
            fontSize: "16px",
            fontWeight: "400",
            color: "#4D4D4D",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Sale Expire Date",
      dataIndex: "saleExpireDate",
      key: "saleExpireDate",
      render: (text) => (
        <span
          style={{
            fontFamily:
              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
            fontSize: "16px",
            fontWeight: "400",
            color: "#4D4D4D",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      render: (text) => (
        <span
          style={{
            fontFamily:
              "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
            fontSize: "16px",
            fontWeight: "400",
            color: "#4D4D4D",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: () => <ActionButtons />,
    },
  ];

  return (
    <div style={{ backgroundColor: "#FAFAFA", flex: 1 }}>
      {/* Main Content Card */}
      <div style={{ margin: "40px 24px" }}>
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
            border: "none",
            overflow: "hidden",
          }}
          bodyStyle={{ padding: "40px" }}
        >
          <Row gutter={[20, 20]} align="middle">
            <Col xs={24} lg={12}>
              <div
                style={{
                  fontFamily:
                    "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                  color: "#4D4D4D",
                  letterSpacing: "0.5px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    marginBottom: "20px",
                  }}
                >
                  <ShoppingOutlined
                    style={{
                      fontSize: "36px",
                      color: "#4D4D4D",
                    }}
                  />
                  <Title
                    level={2}
                    style={{
                      margin: 0,
                      color: "#4D4D4D",
                      fontFamily:
                        "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                      fontSize: "24px",
                      fontWeight: "700",
                      lineHeight: "1",
                    }}
                  >
                    Sales In Progress
                  </Title>
                </div>

                <Text
                  style={{
                    color: "#4D4D4D",
                    fontSize: "18px",
                    fontWeight: "400",
                    lineHeight: "24px",
                    fontFamily:
                      "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
                  }}
                >
                  The Incentive Codes below have been Validated by your shop.
                  <br />
                  Validated Incentive Codes will remain in progress for up to 4
                  weeks or until a Reimbursement Request has been submitted for
                  it.
                  <br />
                  <strong>
                    You must submit a Reimbursement Request within 4 weeks or
                    the transaction will be canceled automatically so that the
                    Incentive Code may be redeemed at a later date.
                  </strong>
                </Text>
              </div>
            </Col>

            <Col xs={24} lg={12}>
              <Image
                src="/images/salesprog.webp"
                alt="E-Bike Sales"
                style={{
                  width: "100%",
                  borderRadius: "0px 10px 10px 0px",
                  aspectRatio: "1.92",
                  objectFit: "cover",
                }}
                preview={false}
              />
            </Col>
          </Row>
        </Card>
      </div>

      {/* Sales Summary and Search */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "30px 24px 10px 24px",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Badge
            count={4}
            style={{
              backgroundColor: "#007AFF",
              fontFamily:
                "Roboto, -apple-system, Roboto, Helvetica, sans-serif",
              fontSize: "16px",
              fontWeight: "500",
              minWidth: "28px",
              height: "28px",
              lineHeight: "28px",
              borderRadius: "100px",
            }}
          />
          <Text
            style={{
              color: "#4D4D4D",
              fontFamily:
                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
              fontSize: "16px",
              fontWeight: "700",
              letterSpacing: "0.5px",
            }}
          >
            Sales In Progress
          </Text>
        </div>

        <Search placeholder="Search" allowClear style={{ width: 300 }} />
      </div>

      {/* Sales Table */}
      <div style={{ margin: "10px 24px 40px 24px" }}>
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
            border: "none",
          }}
          bodyStyle={{ padding: "10px 20px 19px 10px" }}
        >
          <Table
            columns={columns}
            dataSource={salesData}
            pagination={false}
            style={{
              fontFamily:
                "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "1",
            }}
            className="sales-progress-table"
          />
        </Card>
      </div>
    </div>
  );
};

export default SalesInProgress;
